type AcsDataType = {
  acsUrl: string;
  fields?: { [key: string]: string };
};

export const createAndSubmit3DSSecureForm = (acsData: AcsDataType) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = acsData.acsUrl;

  if (acsData.fields) {
    const fieldKeys = Object.keys(acsData.fields);

    fieldKeys.forEach((key) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;

      if (acsData.fields !== undefined) {
        input.value = acsData.fields[key];
        form.appendChild(input);
      }
    });
  }

  document.body.appendChild(form);
  form.submit();
};
